export const colorsDark = {
  main: {
    main: "#0796A6",
    500: "#0796A6",
    600: "#067E8B",
    700: "#05616B",
    800: "#04474F",
    900: "#0F1316",
    1000: "#090C0E",
    text: "#F1F5F9",
    text2: "#CBD5E1",
    text3: "#94A3B8",
    bg_dark: "#0B0D10",
    bg: "#101317",
    bg_light: "#171B21",
    border: "#2A2F36",
    border2: "#1E2228",
    hover: "#1A1F26",
  },
  
  success: {
    main: "#22C55E",
    50: "#ECFDF5",
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#34D399",
    500: "#22C55E",
    600: "#16A34A",
    700: "#15803D",
    800: "#166534",
    900: "#14532D",
    1000: "#052E16",
  },

  warning: {
    main: "#FBBF24", // clean golden yellow
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#EAB308",
    600: "#CA8A04",
    700: "#A16207",
    800: "#854D0E",
    900: "#713F12",
    1000: "#422006",
  },

  error: {
    main: "#EF4444",
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#991B1B",
    900: "#7F1D1D",
    1000: "#450A0A",
  },

  info: {
    main: "#3B82F6",
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A",
    1000: "#172554",
  },

  neutrals: {
    main: "#9AA6AC",
    50: "#F5F7F8",
    100: "#ECEFF1",
    200: "#D6DBDE",
    300: "#B8C1C6",
    400: "#9AA6AC",
    500: "#7C878D",
    600: "#606A70",
    700: "#434B50",
    800: "#2F3539",
    900: "#1F2427",
    1000: "#121517",
  },
};

export const colorsLight = {
  main: {
    main: "#0796a6", //0796a6
    50: "#E0F7FA",
    100: "#B2EBF2",
    200: "#80DEEA",
    300: "#4DD0E1",
    400: "#26C6DA",
    500: "#0796a6",
    600: "#0288A0",
    700: "#006f83",
    800: "#016274",
    900: "#005261",
    1000: "#00454d",
    text: "#212121",
    text2: "#616161",
    text3: "#cfcfcfff",
    bg_dark: "#e4e4e4",
    bg: "#f2f2f2",
    bg_light: "#ffffff",
    secondary: "#DCC7A9",
    highlight: "#E8E6E1",
    border: "#E0E0E0",
    border2: "#F0F0F0",
    disabled: "#F5F5F5",
    hover: "#FAFAFA",
    buttonHover: "#E0F7FA",
    buttonHoverSelected: "#006064",
    active: "#E3F2FD",
  },

  success: {
    main: "#02A73E",
    50: "#EFFCF4",
    100: "#D7F7E3",
    200: "#9DF9BF",
    300: "#4BEF87",
    400: "#1DD862",
    500: "#02A73E",
    600: "#049138",
    700: "#036427",
    800: "#01501E",
    900: "#011E0C",
    1000: "#000E05",
  },

  warning: {
    main: "#EAB308",
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#EAB308",
    600: "#CA8A04",
    700: "#A16207",
    800: "#854D0E",
    900: "#713F12",
    1000: "#422006",
  },

  error: {
    main: "#A70202",
    50: "#FEF6F6",
    100: "#F7D7D7",
    200: "#F99D9D",
    300: "#EF4B4B",
    400: "#D81D1D",
    500: "#A70202",
    600: "#910404",
    700: "#640303",
    800: "#500101",
    900: "#1E0101",
    1000: "#0D0000",
  },

  info: {
    main: "#024FA7",
    50: "#F5F8FB",
    100: "#D7E6F7",
    200: "#9DC8F9",
    300: "#4B98EF",
    400: "#1D74D8",
    500: "#024FA7",
    600: "#044691",
    700: "#033064",
    800: "#012650",
    900: "#010F1E",
    1000: "#00060C",
  },

  neutrals: {
    main: "#757575",
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#757575",
    600: "#616161",
    700: "#424242",
    800: "#333333",
    900: "#212121",
    1000: "#121212",
  },
};

// mui theme settings
export const themeSettings = (mode) => {
  const colors = mode === "dark" ? colorsDark : colorsLight;

  return {
    components: {
      // ============ GLOBAL STYLES ============
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            "& ::-webkit-scrollbar": {
              width: ".45rem",
              height: "0.45rem",
            },
            "& ::-webkit-scrollbar-track": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[900] : colorsLight.main[50],
              //margin: "1rem",
            },
            "& ::-webkit-scrollbar-thumb": {
              borderRadius: "2.5px",
              backgroundColor:
                mode === "dark" ? colorsDark.main[600] : colorsLight.main[300],
            },
            "& ::-webkit-scrollbar-thumb:hover": {
              borderRadius: "2.5px",
              backgroundColor:
                mode === "dark" ? colorsDark.main[400] : colorsLight.main[500],
            },
          },
          body: {
            backgroundColor: colors.main.bg,
            color: colors.main.text,
          },
        },
      },

      // ============ BUTTONS ============
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 600,
            transition: "all 0.3s ease",
            borderRadius: "12px",
          },
          contained: {
            backgroundColor: colors.main.main,
            color: "#ffffff",
            "&:hover": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[400] : colorsLight.main[600],
              boxShadow: `0 4px 12px ${colors.main.main}40`,
            },
            "&:active": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[600] : colorsLight.main[700],
            },
            "&:disabled": {
              backgroundColor: colors.main.disabled,
              color: colors.main.text2,
            },
          },
          outlined: {
            borderColor: colors.main.border,
            color: colors.main.main,
            "&:hover": {
              backgroundColor: colors.main.hover,
              borderColor: colors.main.main,
            },
            "&:disabled": {
              borderColor: colors.main.disabled,
              color: colors.main.disabled,
            },
          },
          text: {
            color: colors.main.main,
            "&:hover": {
              backgroundColor: colors.main.hover,
            },
            "&:disabled": {
              color: colors.main.disabled,
            },
          },
        },
        defaultProps: {
          disableRipple: true,
        },
      },

      // ============ TEXT FIELDS & INPUTS ============
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              py: 0,
              backgroundColor:
                mode === "dark"
                  ? colorsDark.main.bg_light
                  : colorsLight.main.bg_light,
              borderRadius: "12px",
              transition: "all 0.2s ease",
              "& fieldset": {
                borderColor: colors.main.bg_light,
              },
              "&:hover fieldset": {
                borderColor: colors.main.main,
              },
              "&.Mui-focused fieldset": {
                borderColor: colors.main.main,
                borderWidth: "2px",
              },
              "&.Mui-disabled": {
                backgroundColor: colors.main.bg,

                "& .MuiInputBase-input": {
                  color: colors.main.text3,

                  WebkitTextFillColor: colors.main.text3,
                  opacity: 1,
                },
                "& fieldset": {
                  borderColor: colors.main.text3,
                },
              },
            },
            "& .MuiInputBase-input": {
              //padding: "8.5px 12px !important",
              color: colors.main.text,
              "&::placeholder": {
                color: colors.main.text2,
                opacity: 0.7,
              },
              "&:disabled, &[disabled]": {
                color: `${colors.main.text3} !important`,
                WebkitTextFillColor: `${colors.main.text3} !important`,
                opacity: "1 !important",
                caretColor: "transparent !important",
              },
            },
            "& .MuiInputLabel-root": {
              color: colors.main.text2,
              "&.Mui-focused": {
                color: colors.main.main,
              },
            },
          },
        },
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor:
              mode === "dark" ? colorsDark.main[900] : colorsLight.main[50],
            borderRadius: "12px",
            "& fieldset": {
              borderColor: colors.main.border,
            },
            "&:hover fieldset": {
              borderColor: colors.main.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: colors.main.main,
              borderWidth: "2px",
            },
          },
          input: {
            color: colors.main.text,
            "&.Mui-disabled": {
              color: colors.main.text3,
              WebkitTextFillColor: colors.main.text3,
              opacity: 1,
              caretColor: "transparent",
            },
          },
        },
      },

      // ============ DATA GRID (Toolbar Quick Filter) ============
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: "1px solid transparent",
            boxShadow:
              mode === "dark"
                ? "0px 6px 16px rgba(0, 0, 0, 0.6)" // stronger, deeper dark-mode shadow
                : "0px 4px 12px rgba(0, 0, 0, 0.18)", // softer light-mode shadow

            // Selected row styling
            "& .MuiDataGrid-row.Mui-selected > .MuiDataGrid-cell": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[800] : colorsLight.main[100],
              color:
                mode === "dark" ? colorsDark.main.text : colorsLight.main.text,
            },
            "& .MuiDataGrid-row.Mui-selected:hover > .MuiDataGrid-cell": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[700] : colorsLight.main[200],
            },
          },
        },
      },

      // ============ SELECT & AUTOCOMPLETE ============
      MuiSelect: {
        styleOverrides: {
          root: {
            backgroundColor:
              mode === "dark" ? colorsDark.main[900] : colorsLight.main[50],
            borderRadius: "12px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.main.border,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.main.main,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.main.main,
            },
          },
        },
      },

      // ============ CARDS ============
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.bg_light,
            borderColor: colors.main.border2,
            border: `1px solid ${colors.main.border2}`,
            boxShadow:
              mode === "dark"
                ? "0 2px 8px rgba(0, 0, 0, 0.3)"
                : "0 2px 8px rgba(0, 0, 0, 0.08)",
            transition: "all 0.2s ease",
            borderRadius: "12px",
            "&:hover": {
              boxShadow:
                mode === "dark"
                  ? "0 4px 16px rgba(0, 0, 0, 0.5)"
                  : "0 4px 16px rgba(0, 0, 0, 0.12)",
            },
          },
        },
      },

      // ============ DIALOGS & MODALS ============
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.main.bg_light,
            backgroundImage: "none",
            borderRadius: "12px",
            boxShadow:
              mode === "dark"
                ? "0 8px 32px rgba(0, 0, 0, 0.5)"
                : "0 8px 32px rgba(0, 0, 0, 0.15)",
          },
          backdrop: {
            backgroundColor:
              mode === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.4)",
          },
        },
      },

      MuiDialogTitle: {
        styleOverrides: {
          root: {
            fontSize: "20px",
            fontWeight: 600,
            color: colors.main.text,
            borderBottom: `1px solid ${colors.main.border2}`,
          },
        },
      },

      MuiDialogContent: {
        styleOverrides: {
          root: {
            color: colors.main.text,
            padding: "20px",
          },
        },
      },

      // ============ MENUS & POPOVERS ============
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.main.bg_light,
            borderRadius: "12px",
            boxShadow:
              mode === "dark"
                ? "0 4px 16px rgba(0, 0, 0, 0.4)"
                : "0 4px 16px rgba(0, 0, 0, 0.12)",
            border: `1px solid ${colors.main.border2}`,
          },
          list: {
            padding: "8px 0",
          },
        },
      },

      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: colors.main.text,
            padding: "10px 16px",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: colors.main[100],
            },
            "&.Mui-selected": {
              backgroundColor: `${colors.main.main}20`,
              color: colors.main.main,
              "&:hover": {
                backgroundColor: `${colors.main.main}30`,
              },
            },
          },
        },
      },

      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.main.bg_light,
            borderRadius: "12px",
            border: `1px solid ${colors.main.border2}`,
          },
        },
      },

      // ============ CHIPS ============
      MuiChip: {
        styleOverrides: {
          root: {
            backgroundColor: `${colors.main.main}20`,
            color: colors.main.main,
            borderRadius: "10px",
            fontWeight: 500,
            transition: "all 0.2s ease",
            border: `1px solid ${colors.main.main}40`,
            "&:hover": {
              backgroundColor: `${colors.main.main}30`,
              boxShadow: `0 2px 8px ${colors.main.main}20`,
            },
          },
          filled: {
            backgroundColor: colors.main.main,
            color: "#ffffff",
            border: "none",
            "&:hover": {
              backgroundColor:
                mode === "dark" ? colorsDark.main[400] : colorsLight.main[600],
            },
          },
          outlined: {
            borderColor: colors.main.border,
            color: colors.main.text,
            "&:hover": {
              backgroundColor: colors.main.hover,
            },
          },
          colorSuccess: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.success.main}20`
                : `${colorsLight.success.main}20`,
            color:
              mode === "dark"
                ? colorsDark.success.main
                : colorsLight.success.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.success.main}40`
                : `1px solid ${colorsLight.success.main}40`,
          },
          colorError: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.error.main}20`
                : `${colorsLight.error.main}20`,
            color:
              mode === "dark" ? colorsDark.error.main : colorsLight.error.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.error.main}40`
                : `1px solid ${colorsLight.error.main}40`,
          },
          colorWarning: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.warning.main}20`
                : `${colorsLight.warning.main}20`,
            color:
              mode === "dark"
                ? colorsDark.warning.main
                : colorsLight.warning.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.warning.main}40`
                : `1px solid ${colorsLight.warning.main}40`,
          },
        },
      },

      // ============ TABLES & DATAGRID ============
      MuiTableContainer: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.bg_light,
            borderRadius: "12px",
            border: `1px solid ${colors.main.border2}`,
          },
        },
      },

      MuiTable: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.bg_light,
          },
        },
      },

      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor:
              mode === "dark" ? colorsDark.main[800] : colorsLight.main[100],
          },
        },
      },

      MuiTableCell: {
        styleOverrides: {
          root: {
            color: colors.main.text,
            borderColor: colors.main.border2,
            padding: "12px 16px",
            fontSize: "14px",
          },
          head: {
            fontWeight: 600,
            color: colors.main.text,
            backgroundColor:
              mode === "dark" ? colorsDark.main[800] : colorsLight.main[100],
            borderBottom: `2px solid ${colors.main.border}`,
          },
          body: {
            borderBottom: `1px solid ${colors.main.border2}`,
          },
        },
      },

      MuiTableRow: {
        styleOverrides: {
          root: {
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: colors.main.hover,
            },
            "&.Mui-selected": {
              backgroundColor: `${colors.main.main}15`,
              "&:hover": {
                backgroundColor: `${colors.main.main}25`,
              },
            },
          },
        },
      },

      // ============ APPBAR ============
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.bg_light,
            color: colors.main.text,
            boxShadow: `0 2px 8px ${
              mode === "dark" ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.1)"
            }`,
            borderBottom: `1px solid ${colors.main.border2}`,
          },
        },
      },

      // ============ DRAWER ============
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: colors.main.bg_light,
            borderRight: `1px solid ${colors.main.border2}`,
            color: colors.main.text,
          },
        },
      },

      // ============ TABS ============
      MuiTabs: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${colors.main.border2}`,
            backgroundColor: colors.main.bg_light,
          },
          indicator: {
            backgroundColor: colors.main.main,
            height: "3px",
          },
        },
      },

      MuiTab: {
        styleOverrides: {
          root: {
            color: colors.main.text2,
            textTransform: "none",
            fontWeight: 500,
            transition: "all 0.2s ease",
            fontSize: "14px",
            "&:hover": {
              color: colors.main.text,
              backgroundColor: colors.main.hover,
            },
            "&.Mui-selected": {
              color: colors.main.main,
              fontWeight: 600,
            },
          },
        },
      },

      // ============ ALERTS ============
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: 500,
          },
          standardSuccess: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.success.main}15`
                : `${colorsLight.success.main}15`,
            color:
              mode === "dark"
                ? colorsDark.success.main
                : colorsLight.success.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.success.main}40`
                : `1px solid ${colorsLight.success.main}40`,
          },
          standardError: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.error.main}15`
                : `${colorsLight.error.main}15`,
            color:
              mode === "dark" ? colorsDark.error.main : colorsLight.error.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.error.main}40`
                : `1px solid ${colorsLight.error.main}40`,
          },
          standardWarning: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.warning.main}15`
                : `${colorsLight.warning.main}15`,
            color:
              mode === "dark"
                ? colorsDark.warning.main
                : colorsLight.warning.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.warning.main}40`
                : `1px solid ${colorsLight.warning.main}40`,
          },
          standardInfo: {
            backgroundColor:
              mode === "dark"
                ? `${colorsDark.info.main}15`
                : `${colorsLight.info.main}15`,
            color:
              mode === "dark" ? colorsDark.info.main : colorsLight.info.main,
            border:
              mode === "dark"
                ? `1px solid ${colorsDark.info.main}40`
                : `1px solid ${colorsLight.info.main}40`,
          },
        },
      },

      // ============ CHECKBOXES & RADIO BUTTONS ============
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: colors.main.border,
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: `${colors.main.main}10`,
            },
            "&.Mui-checked": {
              color: colors.main.main,
            },
            "&.Mui-disabled": {
              color: colors.main.disabled,
            },
          },
        },
      },

      MuiRadio: {
        styleOverrides: {
          root: {
            color: colors.main.border,
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: `${colors.main.main}10`,
            },
            "&.Mui-checked": {
              color: colors.main.main,
            },
            "&.Mui-disabled": {
              color: colors.main.disabled,
            },
          },
        },
      },

      // ============ SWITCH ============
      MuiSwitch: {
        styleOverrides: {
          root: {
            width: "44px",
            height: "24px",
            padding: 0,
          },
          switchBase: {
            color: colors.main.border,
            margin: 0,
            padding: 0,
            "& .MuiSwitch-thumb": {
              width: "22px",
              height: "22px",
              borderRadius: "8px",
              boxShadow: "none",
              marginTop: "1px", // 1px top + bottom within 24px track
              //marginLeft: '1px', // 1px left when OFF
            },
            "&.Mui-checked": {
              color: colors.main.main,
              "& + .MuiSwitch-track": {
                backgroundColor: `${colors.main.main}40`,
              },
            },
          },
          track: {
            backgroundColor: colors.main.bg_light,
            height: "24px",
            borderRadius: "8px",
          },
        },
      },

      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            columnGap: "8px",
          },
          label: {
            marginLeft: "2px",
          },
        },
      },

      // ============ PAGINATION ============
      MuiPagination: {
        styleOverrides: {
          root: {
            "& .MuiButtonBase-root": {
              color: colors.main.text,
              border: `1px solid ${colors.main.border2}`,
              borderRadius: "12px",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: colors.main.hover,
                borderColor: colors.main.main,
              },
            },
            "& .Mui-selected": {
              backgroundColor: colors.main.main,
              color: "#ffffff",
              border: `1px solid ${colors.main.main}`,
              "&:hover": {
                backgroundColor:
                  mode === "dark"
                    ? colorsDark.main[400]
                    : colorsLight.main[600],
              },
            },
          },
        },
      },

      // ============ BADGES ============
      MuiBadge: {
        styleOverrides: {
          badge: {
            backgroundColor: colors.main.main,
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "12px",
          },
        },
      },

      // ============ TOOLTIP ============
      MuiTooltip: {
        defaultProps: {
          arrow: true,
          enterDelay: 300,
          enterNextDelay: 150,
          placement: "top",
        },
        styleOverrides: {
          // the floating bubble
          tooltip: ({ theme }) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? theme.palette.grey[900]
                : theme.palette.grey[800],
            color: theme.palette.common.white,
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.25,
            borderRadius: 8,
            padding: "8px 10px",
            maxWidth: 280,
          }),

          // when arrow=true, the tooltip wrapper gets a different class
          tooltipArrow: ({ theme }) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? theme.palette.grey[900]
                : theme.palette.grey[800],
          }),

          // arrow color
          arrow: ({ theme }) => ({
            color:
              theme.palette.mode === "dark"
                ? theme.palette.grey[900]
                : theme.palette.grey[800],
          }),

          // popper container (zIndex, spacing tweaks, etc.)
          popper: ({ theme }) => ({
            zIndex: theme.zIndex.modal + 1,
          }),
        },
      },

      // ============ PROGRESS ============
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.disabled,
            borderRadius: "4px",
          },
          bar: {
            backgroundColor: colors.main.main,
            borderRadius: "4px",
          },
        },
      },

      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: colors.main.main,
          },
        },
      },

      // ============ BACKDROP ============
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor:
              mode === "dark" ? "rgba(0, 0, 0, 0.6)" : "rgba(0, 0, 0, 0.4)",
          },
        },
      },

      // ============ SNACKBAR ============
      MuiSnackbarContent: {
        styleOverrides: {
          root: {
            backgroundColor: colors.main.bg,
            color: colors.main.text,
            borderRadius: "12px",
            boxShadow:
              mode === "dark"
                ? "0 4px 16px rgba(0, 0, 0, 0.4)"
                : "0 4px 16px rgba(0, 0, 0, 0.12)",
          },
        },
      },
    },
    palette: {
      mode: mode,
      primary: colors.main,
      secondary: colors.main,
      grey: colors.neutrals,
      success: colors.success,
      warning: colors.warning,
      error: colors.error,
      info: colors.info,
      background: {
        default: colors.main.bg_light,
        alt: colors.main.bg,
        info: mode === "dark" ? colors.info[800] : colors.info[200],
      },
    },
    typography: {
      fontFamily: ["Work Sans", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 40,
        fontWeight: 700,
        color: colors.main.text,
      },
      h2: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 32,
        fontWeight: 700,
        color: colors.main.text,
      },
      h3: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 24,
        fontWeight: 600,
        color: colors.main.text,
      },
      h4: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 20,
        fontWeight: 600,
        color: colors.main.text,
      },
      h5: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 16,
        fontWeight: 500,
        color: colors.main.text,
      },
      h6: {
        fontFamily: ["Terminal Dosis", "sans-serif"].join(","),
        fontSize: 14,
        fontWeight: 500,
        color: colors.main.text2,
      },
      body1: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 14,
        color: colors.main.text,
      },
      body3: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 12,
        color: colors.main.text,
      },
      body2: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 14,
        fontWeight: 400,
        color: colors.main.text2,
      },
      subtitle1: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 16,
        fontWeight: 500,
        color: colors.main.main,
      },
      subtitle2: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 14,
        fontWeight: 400,
        color: colors.main.text2,
      },
      button: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        textTransform: "none",
        fontWeight: 600,
        fontSize: 14,
      },
      caption: {
        //fontFamily: ["Open Sans", "sans-serif"].join(","),
        fontSize: 12,
        color: colors.main.text2,
      },
    },
  };
};

// ============ REUSABLE COMPONENT STYLES ============

/**
 * Grid Button Selector Styles
 * Used for month/year selector buttons and similar grid-based button selections
 * Provides consistent styling across the application
 */
export const getGridButtonSelectorStyles = (theme, isSelected) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  p: 1,
  borderRadius: "12px",
  cursor: "pointer",
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: isSelected ? theme.palette.primary.main : "transparent",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: theme.palette.primary[200],
    boxShadow: `0 2px 8px ${theme.palette.primary.main}20`,
  },
  "&:active": {
    backgroundColor: theme.palette.primary[300],
  },
});

/**
 * Save Button Styles
 * Used for action buttons with disabled state
 * Provides consistent styling for save/confirm buttons
 */
export const getSaveButtonStyles = (theme, isDisabled) => ({
  backgroundColor: isDisabled
    ? theme.palette.action.disabledBackground
    : theme.palette.primary.main,
  color: isDisabled
    ? theme.palette.action.disabled
    : theme.palette.background.alt,
  borderRadius: "12px",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: isDisabled
      ? theme.palette.action.disabledBackground
      : theme.palette.mode === "dark"
        ? theme.palette.primary[400]
        : theme.palette.primary[600],
  },
});

export const getTextFieldBorderStyles = (borderColor) => ({
  "& .MuiInputBase-input": {
    padding: "8.5px 12px !important",
  },
  "& .MuiOutlinedInput-root": {
    py: 0,
    "&.MuiInputBase-root fieldset": {
      borderColor: borderColor,
      //borderBottomColor: "#FF9800",
      //borderBottomWidth: "2px",
    },
  },
});

// ============ CHART COLOR UTILITIES ============

/**
 * Chart Colors
 * Returns semantic color palette for charts following design guidelines:
 * - Primary data → main.main
 * - Secondary → info.main
 * - Positive → success.main
 * - Warning → warning.main
 * - Negative → error.main
 * - Extra series → neutrals (500 → 700)
 * 
 * Charts should feel secondary - supporting data, not competing with UI
 * Use neutrals for structural elements (grid lines, axes, labels)
 * 
 * @param {Object} theme - MUI theme object
 * @returns {Object} Chart color configuration
 */
export const getChartColors = (theme) => {
  const isLight = theme.palette.mode === "light";
  
  return {
    // Semantic colors in priority order
    series: [
      theme.palette.primary.main,        // Primary data
      theme.palette.info.main,           // Secondary
      theme.palette.success.main,        // Positive
      theme.palette.warning.main,        // Warning
      theme.palette.error.main,          // Negative
      theme.palette.grey[500],           // Extra series 1
      theme.palette.grey[600],           // Extra series 2
      theme.palette.grey[700],           // Extra series 3
    ],
    
    // Structural elements (neutrals only)
    grid: theme.palette.grey[isLight ? 300 : 700],
    axis: theme.palette.grey[isLight ? 400 : 600],
    label: theme.palette.text.secondary,
    zeroLine: theme.palette.grey[isLight ? 500 : 500],
    
    // Semantic specific colors (for explicit use)
    semantic: {
      primary: theme.palette.primary.main,
      secondary: theme.palette.info.main,
      positive: theme.palette.success.main,
      warning: theme.palette.warning.main,
      negative: theme.palette.error.main,
    },
  };
};

/**
 * Get Chart Structural Styles
 * Returns consistent styling for chart structural elements
 * All structural elements use neutrals only
 * 
 * @param {Object} theme - MUI theme object
 * @returns {Object} Chart structural styles
 */
export const getChartStructuralStyles = (theme) => {
  const colors = getChartColors(theme);
  
  return {
    "& .MuiChartsAxis-line": {
      stroke: colors.axis,
    },
    "& .MuiChartsAxis-tick": {
      stroke: colors.axis,
    },
    "& .MuiChartsAxis-tickLabel": {
      fill: colors.label,
    },
    "& .MuiChartsGrid-line": {
      stroke: colors.grid,
      strokeDasharray: "3 3",
      strokeOpacity: 0.6,
    },
  };
};
